import React, { useEffect, useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { getSettingsData } from '../reducer';
import { showGlobalConfirm } from '../../System/actions';
import { checkBoxFormatter } from '../../../utils/formatters';
import Grid from '../../../components/base/Grid/Grid';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import FileInput from '../../../components/fields/FileInput/FileInput';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { getSystemData } from '../../System/reducer';
import {
  addToViolationList, deleteFromViolationList, importViolationList, loadViolationList,
} from '../actions';
import { getResponseError, responseLogWithNotification, useUpdatePeriod } from '../../../utils/utils';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import Loader from '../../../components/base/Loader/Loader';
import UploadZone from '../../../components/fields/FileInput/UploadZone';

export default function ViolationColumns() {
  const [selected, setSelected] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [filter, setFilter] = useState('');
  const [newCodeDescription, setNewCodeDescription] = useState('');
  const [newDescription, setNewDescription] = useState('');
  const [newCode, setNewCode] = useState('');
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const { updatePeriod } = useSelector(getSystemData);
  const {
    loadingViolationList, violationList, loadingAddToViolationList, loadingDeleteFromViolationList, loadingImportViolationList,
  } = useSelector(getSettingsData);
  const loadData = () => {
    const p1 = dispatch(loadViolationList()).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const setFileClear = f => { window.clearFileFunction = f; };

  const cancel = () => {
    if (window.clearFileFunction) {
      window.clearFileFunction();
    }
  };

  const handleImportFile = data => {
    dispatch(importViolationList(data)).then(() => {
      loadData();
      setShowUpload(false);
      cancel();
      successNotification(formatMessage({ id: 'violation.import' }), formatMessage({ id: 'violation.import.success' }));
    }).catch(response => {
      if (response && response.errors && response.errors.length) {
        return errorNotification(formatMessage({ id: 'violation.import' }), response.errors.map(i => i.message).slice(0, 3).join('\n '));
      }
      errorNotification(formatMessage({ id: 'violation.import' }), getResponseError(response));
      cancel();
    });
  };

  const handleDelete = event => {
    dispatch(showGlobalConfirm({
      confirmMessage: formatMessage({ id: 'violation.delete' }),
      confirmButtonText: formatMessage({ id: 'app.delete' }),
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteFromViolationList(selected)).then(() => {
        loadData();
        successNotification(formatMessage({ id: 'violation.delete.title' }), formatMessage({ id: 'violation.delete.success' }));
      }).catch(response => {
        errorNotification(formatMessage({ id: 'violation.delete.title' }), getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleAdd = event => {
    dispatch(addToViolationList({ code_description: newCodeDescription, description: newDescription, duplo_code: Number(newCode) })).then(() => {
      loadData().then(() => {
        setShowCreate(false);
        setNewCode('');
      });
      successNotification(formatMessage({ id: 'violation.add' }), formatMessage({ id: 'violation.add.success' }));
    }).catch(response => errorNotification(formatMessage({ id: 'violation.add' }), getResponseError(response)));
  };

  const headerCheckBoxFormatter = (id, item) => {
    const isAll = violationList.every(p => selected.includes(p.id));
    const isSome = violationList.some(p => selected.includes(p.id)) && !isAll;
    const onChange = () => {
      if (isAll) {
        setSelected([]);
      } else {
        setSelected(violationList.map(p => p.id));
      }
    };
    return checkBoxFormatter(isAll, onChange, classNames({ 'some-child': isSome }, { 'every-child': isAll }));
  };

  const rowCheckBoxFormatter = (_, item) => {
    const onChange = () => {
      const index = selected.indexOf(item.id);
      if (index >= 0) {
        const newSelected = [...selected];
        newSelected.splice(index, 1);
        setSelected(newSelected);
      } else {
        setSelected([...selected, item.id]);
      }
    };
    return checkBoxFormatter(selected.includes(item.id), onChange);
  };

  const columns = [
    {
      dataField: 'checkbox',
      text: formatMessage({ id: 'select.row' }),
      disableSort: true,
      headerFormatter: headerCheckBoxFormatter,
      formatter: rowCheckBoxFormatter,
      dataClassName: 'checkbox-column',
      headerClassName: 'checkbox-column',
    },
    {
      dataField: 'code_description',
      text: formatMessage({ id: 'export.data.violation_types' }),
      headerClassName: 'reg-number-column',
      disableSort: true,
    },
    {
      dataField: 'description',
      text: formatMessage({ id: 'violation' }),
      headerClassName: 'reg-number-column',
      disableSort: true,
    },
    {
      dataField: 'duplo_code',
      text: formatMessage({ id: 'violation.code.short' }),
      headerClassName: 'reg-number-column',
      disableSort: true,
    },
  ];
  const filteredList = (violationList || []).filter(item => String(item.code_description).toLowerCase().includes(String(filter).toLowerCase()));
  const renderContent = () => (
    <div className="wanted-data">
      <Grid columns={columns} data={filteredList} />
    </div>
  );

  const renderCreateDialog = () => (
    <Dialog
      className={classNames('calibration-dialog-container')}
      onClose={() => { setShowCreate(false); }}
      open
    >
      <DialogTitle header={formatMessage({ id: 'preset.violation_type_id' })} title={<Icons onClick={() => { setShowCreate(false); }} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content">
        <TextInputWithLabel
          label={formatMessage({ id: 'export.data.violation_types' })}
          variant="material"
          placeholder={formatMessage({ id: 'exception.base.placeholder' })}
          inputProps={{
            value: newCodeDescription,
            onChange: e => setNewCodeDescription(e.target.value),
          }}
        />
        <TextInputWithLabel
          className="mt-3"
          label={formatMessage({ id: 'violation' })}
          variant="material"
          placeholder={formatMessage({ id: 'violation.placeholder' })}
          inputProps={{
            value: newDescription,
            onChange: e => setNewDescription(e.target.value),
          }}
        />
        <TextInputWithLabel
          className="mt-3"
          label={formatMessage({ id: 'violation.code' })}
          variant="material"
          placeholder={formatMessage({ id: 'violation.code.placeholder' })}
          inputProps={{
            value: newCode,
            onChange: e => setNewCode(e.target.value),
          }}
        />
      </DialogContent>
      <DialogFooter>
        <Button onClick={handleAdd}>{formatMessage({ id: 'app.save' })}</Button>
        <Button variant="secondary" onClick={() => { setShowCreate(false); }}>{formatMessage({ id: 'app.close' })}</Button>
      </DialogFooter>
    </Dialog>
  );

  const renderUpload = () => (
    <UploadZone inputProps={{ onChange: handleImportFile }} setClear={setFileClear} zoneText={formatMessage({ id: 'violation.import.file' })} />
  );

  return (
    <div className="settings-options frame wanted-column">
      <Loader loading={loadingViolationList || loadingAddToViolationList || loadingDeleteFromViolationList || loadingImportViolationList} />
      <div className="settings-edit">
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'menu.settings_violation' })}</div>
          <div className="settings-buttons wanted-buttons">
            {violationList.length ? (
              <>
                <TextInput
                  inputProps={{
                    value: filter,
                    onChange: e => setFilter(e.target.value),
                  }}
                  placeholder={formatMessage({ id: 'search' })}
                  inputBefore={(
                    <div className="search-wrapper">
                      <Icons customIcon className="search" width={24} height={24} icon="search" />
                    </div>
                  )}

                />
                <div className="control-delimiter" />
                <div
                  className="settings-icon-btn"
                  onClick={() => { setShowUpload(!showUpload); }}
                >
                  <Icons customIcon icon="file-export" className="icon" />
                </div>
                <div className="control-delimiter" />

              </>
            ) : null}
            <div
              className="settings-icon-btn"
              onClick={() => {
                setShowCreate(true);
              }}
            >
              <Icons width={26} height={26} customIcon icon="plus" className="icon" />
            </div>
            {violationList.length ? (
              <>
                <div className="control-delimiter" />
                <div
                  className={classNames('settings-icon-btn blue', { disabled: !selected.length })}
                  onClick={handleDelete}
                >
                  <Icons width={20} height={20} customIcon icon="trash" className="icon" />
                </div>
              </>
            ) : null}
          </div>
        </div>
        <div className="settings-form">
          <div className="settings-view-form">
            {!violationList.length || showUpload ? renderUpload() : renderContent()}
            {showCreate ? renderCreateDialog() : null}
          </div>
        </div>
      </div>
    </div>
  );
}
